// AgevolazioniList.js

import React, { useState } from 'react';
import Agevolazione from './Agevolazione';
import 'bootstrap/dist/css/bootstrap.min.css';
import ModalView from './ModalView';

const AgevolazioniList = () => {
  // Stato per memorizzare i dati inseriti dall'utente
  const [isee, setIsee] = useState('');
  const [personeACarico, setPersoneACarico] = useState('');
  const [proprietarioDiCasa, setProprietarioDiCasa] = useState(false);
  const [agevolazioniCalcolate, setAgevolazioniCalcolate] = useState([]);
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');
  

  // Funzione per gestire l'invio del modulo
  const handleSubmit = (event) => {
    event.preventDefault();

    // Chiamiamo la funzione di calcolo con i dati inseriti dall'utente
    const agevolazioniCalcolate = calcolaAgevolazioni(isee, personeACarico, proprietarioDiCasa);

    // Ora puoi fare qualcosa con l'elenco di agevolazioniCalcolate (ad esempio, salvarlo nello stato o visualizzarlo)
    setAgevolazioniCalcolate(agevolazioniCalcolate);
   };

const handleClose = (event) => {
    event.preventDefault();

    setShow(false);
   };

  // Funzione di calcolo delle agevolazioni
  const calcolaAgevolazioni = (isee, personeACarico, proprietarioDiCasa) => {
    // Qui inseriremo la logica per calcolare le agevolazioni in base all'ISEE, reddito e persone a carico.
    // Questa è solo una logica di esempio. Dovresti adattarla alle tue specifiche esigenze.
    const agevolazioniCalcolate = [];

if (isee === "" || personeACarico === "" )
    {
        setShow(true);
        setMessage('Tutti i campi devono essere compilati: isee, persone a carico ecc.');
    }

    else if (isNaN(parseInt(isee)) || isNaN(parseInt(personeACarico)))
    {
      setShow(true);
      setMessage("L'ISEE o le persone a carico sono numeri interi!");
      
    } else
    {
        // Implementa la logica di calcolo delle agevolazioni qui...

  if (isee < 9360) {
    agevolazioniCalcolate.push({
      nome: 'Assegno di inclusione',
      descrizione: "Dal 1 gennaio 2024 si può usufruire di un sussidio mensile di 500 euro minime",
      requisiti: "Requisiti: Avere un ISEE inferiore a 9360 euro con disabili, minori o ultrasessantenni nel proprio nucleo familiare",
    });

  }

if (isee < 6000) {
    agevolazioniCalcolate.push({
      nome: 'Supporto alla formazione e al lavoro',
      descrizione: "Dal 1 settembre 2023 si può usufruire di un sussidio mensile di 350 euro, partecipando a percorsi di formazione e lavoro",
      requisiti: "Requisiti: Avere un ISEE inferiore a 6000 euro, non rifiutare offerte di lavoro e non usufruire dell'assegno di inclusione" ,
    });

  }

if (isee < 15000) {
    agevolazioniCalcolate.push({
      nome: 'Carta dedicata a te',
      descrizione: "Bonus di 382,50 euro una volta sola",
      requisiti: "Requisiti: Essere in un nucleo familiare di almeno 3 persone con ISEE inferiore a 15.000 euro richiesto prima del 12 maggio 2023" ,
    });

  }



  if (personeACarico > 0) {
      agevolazioniCalcolate.push({
        nome: 'Assegno Unico e Universale (AUU)',
        descrizione: 'Prestazione erogata mensilmente dall’INPS a tutti i nuclei familiari per ogni figlio minorenne a carico',
        requisiti: 'Effettuare il calcolo della prestazione con il simulatore INPS qui : https://servizi2.inps.it/servizi/AssegnoUnicoFigli/Simulatore',
      });

      agevolazioniCalcolate.push({
        nome: 'Bonus asilo nido',
        descrizione: "Importo da 1500 a 3000 euro in base all'ISEE",
        requisiti: "Requisiti: avere minori all'asilo",
      });
  }

  if (personeACarico > 0 && isee < 3000) {
    agevolazioniCalcolate.push({
      nome: 'Bonus figli disabili',
      descrizione: 'Fino a 500 euro al mese in favore di genitori senza occupazione, soli o monoreddito con figli affetti da disabilità',
      requisiti: "Requisiti: Disabilità del figlio superiore al 60%",
    });

  }


 if (isee < 30000) {
    agevolazioniCalcolate.push({
      nome: 'Bonus Università',
      descrizione: "Riduzione dal 10% all'80% sulla tassa di iscrizione in base all'ISEE ",
      requisiti: "Requisiti: Essere studenti universitari con ISEE inferiore a 30.000 euro",
    });

  }

if (isee < 15000) {
    agevolazioniCalcolate.push({
      nome: 'Bonus sociale bollette',
      descrizione: "Sconto sulle bollette energetiche",
      requisiti: "Requisiti: Presentazione di una dichiarazione sostitutiva unica e attestazione Isee inferiore a 15.000 euro",
    });

  }


    agevolazioniCalcolate.push({
      nome: 'Bonus e contributo affitti',
      descrizione: "Bonus affitti per giovani under 31 e Misura Unica Affitto",
      requisiti: "Requisiti: ogni Comune stabilisce la propria soglia ISEE per accedere al contributo",
    });


if (isee < 40000) {
    agevolazioniCalcolate.push({
      nome: 'Bonus prima casa under 36',
      descrizione: "Esenzioni e sgravi fiscali per giovani under 36 per l'acquisto di prima casa",
      requisiti: "Requisiti: Avere meno di 36 anni e un ISEE inferiore a 40.000 euro",
    });

  }

if (proprietarioDiCasa) {

agevolazioniCalcolate.push({
      nome: 'Ristrutturazioni edilizie',
      descrizione: "Detrazione IRPEF al 50% o cessione del credito o sconto in fattura fino a 96.000 euro",
      requisiti: "Requisiti: Essere proprietari di casa",
    });

agevolazioniCalcolate.push({
      nome: 'Bonus mobili',
      descrizione: "Detrazione IRPEF al 50% per acquisto mobili, grandi elettrodomestici ecc.",
      requisiti: "Requisiti: Essere proprietari di casa ed avere in corso una ristrutturazione edilizia",
    });


agevolazioniCalcolate.push({
      nome: 'Bonus verde',
      descrizione: "Detrazione IRPEF al 36% per sistemazione a verde fino a 1800 euro",
      requisiti: "Requisiti: Essere proprietari di casa",
    });


agevolazioniCalcolate.push({
      nome: 'Riqualificazione energetica',
      descrizione: "Detrazione IRPEF fino al 65% (pannelli solari, climatizzazione, miglioramento termico ecc. )",
      requisiti: "Requisiti: Essere proprietari di casa",
    });

 }


if (isee < 10000) {
    agevolazioniCalcolate.push({
      nome: 'Bonus occhiali da vista',
      descrizione: "Contributo di 50 euro per l'acquisto di occhiali ",
      requisiti: "Requisiti: ISEE inferiore a 10.000 euro",
    });

  }

if (isee < 50000) {
    agevolazioniCalcolate.push({
      nome: 'Bonus psicologo',
      descrizione: "Contributo di 1500 euro per sedute psicologo da 50 euro cadauna ",
      requisiti: "Requisiti: ISEE inferiore a 50.000 euro",
    });

  }

if (isee < 20000) {
    agevolazioniCalcolate.push({
      nome: 'Bonus TV-decoder',
      descrizione: "Contributo di 30 euro per l'acquisto di un TV o decoder ",
      requisiti: "Requisiti: ISEE inferiore a 20.000 euro",
    });

  }
    
 }

 
    return agevolazioniCalcolate;
  };

  return (
    <div className="container-fluid">
      <h1 className="text-center text-primary">Calcolo Agevolazioni, Bonus e Sussidi</h1>
      <p className="text-center text-secondary">Nessun dato verrà salvato nel calcolo</p>
      <form onSubmit={handleSubmit}>
        <label className="input-group-text">
          <a target='_blank' href='https://servizi2.inps.it/servizi/ISEEPrecompilato/WfSimHome.aspx'>Calcolo dell'ISEE nel sito dell'INPS</a>
        </label>
        <label className="input-group-text">
          Inserire il proprio reddito ISEE:
          <input className="form-control" type="number" value={isee} onChange={(e) => setIsee(e.target.value)} />
        </label>
        <label className="input-group-text">
          Inserire il numero di minori a carico:
          <input className="form-control" type="number" value={personeACarico} onChange={(e) => setPersoneACarico(e.target.value)} />
        </label>
        <label className="input-group-text">
          Selezionare se proprietario di casa:
          <input className='form-check-input' type="checkbox" checked={proprietarioDiCasa} onChange={(e) => setProprietarioDiCasa(e.target.checked)} />
        </label>
        <button className="btn btn-primary" type="submit">Calcola Agevolazioni</button>
      </form>
      
      
        <h2 className="text-center text-secondary">Le tue {agevolazioniCalcolate.length} agevolazioni potrebbero essere:</h2>
        {agevolazioniCalcolate.length > 0 ? (
          agevolazioniCalcolate.map((agevolazione, index) => (
            <Agevolazione
              key={index}
              nome={agevolazione.nome}
              descrizione={agevolazione.descrizione}
              requisiti={agevolazione.requisiti}
            />
          ))
        ) : (
          <p>Nessuna agevolazione calcolata.</p>
        )}
      
 <ModalView message={message} show={show} handleClose={handleClose}
              />

    </div>
  );
};

export default AgevolazioniList;
